const lbaCompanyReferenceCodeSelect = angular.module('app.lbaCompanyReferenceCodeSelect', []);

lbaCompanyReferenceCodeSelect.controller('lbaCompanyReferenceCodeSelectCtrl', require('./lbaCompanyReferenceCodeSelectCtrl'));
lbaCompanyReferenceCodeSelect.directive('lbaCompanyReferenceCodeSelect', require('./lbaCompanyReferenceCodeSelectDir'));

export default lbaCompanyReferenceCodeSelect;



// WEBPACK FOOTER //
// ./src/components/lbaCompanyReferenceCodeSelect/index.js